import axios from "axios";
import { baseUrlOtodisDocument } from "../../config/api/apiConfig";

class DocUploadApiService {
  axios = axios.create({
    baseURL: baseUrlOtodisDocument,
  });

  // public setToken(token: string) {
  //   this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  // }

  async uploadDocEngine(formData: any) {
    try {
      return await this.axios.post("/upload/document/engine", formData);
    } catch (e: any) {
      // console.log(e);

      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async uploadStockInvoice(formData: any) {
    try {
      return await this.axios.post("/upload/document/stock/invoice-file", formData);
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  async uploadTaxInvoice(formData: any) {
    try {
      return await this.axios.post("/upload/document/tax-invoice", formData);
    } catch (e: any) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.message);
    }
  }

  async uploadDocumentHadover(formData: any) {
    try {
      return await this.axios.post("/service-bureau/order/handover", formData);
    } catch (e: any) {
      throw new Error(e?.response?.data?.error?.message);
    }
  }

  async extractNotice(formData: any) {
    try {
      return await this.axios.post("/extract/document/notice", formData);
    } catch (e: any) {
      throw new Error(e?.response?.data?.error?.message);
    }
  }

  async uploadNotice(formData: any) {
    try {
      return await this.axios.post("/upload/document/service-bureau/order/notice", formData);
    } catch (e: any) {
      throw new Error(e?.response?.data?.error?.message);
    }
  }

  async uploadInvoicePdfVinfast(formData: any) {
    try {
      return await this.axios.post("/extract/document/pdf/vinfast", formData);
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }
}

export const docUploadApiService = new DocUploadApiService();
